import { useMemo } from "react";
import { Loading } from "../components/Loading";
import { useQRLandingData } from "./QRLanding/useQRLandingData";
import { getCountryCode } from "./QRLanding/utils/countryUtils";
import { QRLandingDO, QRLandingAR, QRLandingDefault } from "./QRLanding/countries";
import DivixLogo from "../assets/img/divixNegro.png";

const QRLanding = () => {
  const {
    employee,
    rating,
    animatedRating,
    isAnimating,
    comment,
    error,
    isLoading,
    userId,
    branchId,
    setComment,
    setError,
    handleRatingChange,
    handleRatingChangeActive,
    MAX_CHARACTERS,
  } = useQRLandingData();

  const countryCode = useMemo(() => {
    return getCountryCode(employee?.countryIsoCode);
  }, [employee?.countryIsoCode]);

  // Si hay un error de carga, mostrarlo
  if (error.load) {
    return (
      <div className="flex flex-col min-h-screen">
        <div 
          className="h-56 flex items-center justify-center pt-20"
          style={{
            backgroundColor: "#e0e0e0",
          }}
        >
          <img 
            className="mx-auto"
            style={{
              maxWidth: '180px',
              maxHeight: '90px',
              width: 'auto',
              height: 'auto',
              objectFit: 'contain'
            }}
            src={DivixLogo} 
            alt="Logo" 
          />
        </div>
        <div className="text-center mt-12 mx-auto max-w-md">
          <h3 className="w-[318px] text-wrap mx-auto text-center font-light text-md sm:text-xl">
            {error.load}
          </h3>
        </div>
      </div>
    );
  }

  if (isLoading || !employee) {
    return <Loading />;
  }

  // Router por país - fácil de extender agregando más casos
  switch (countryCode) {
    case "DO":
      return (
        <QRLandingDO
          employee={employee}
          error={error}
          rating={rating}
          animatedRating={animatedRating}
          isAnimating={isAnimating}
          comment={comment}
          setComment={setComment}
          setError={setError}
          handleRatingChange={handleRatingChange}
          handleRatingChangeActive={handleRatingChangeActive}
          MAX_CHARACTERS={MAX_CHARACTERS}
          userId={userId}
          branchId={branchId}
        />
      );
    case "AR":
      return (
        <QRLandingAR
          employee={employee}
          error={error}
          rating={rating}
          animatedRating={animatedRating}
          isAnimating={isAnimating}
          comment={comment}
          setComment={setComment}
          setError={setError}
          handleRatingChange={handleRatingChange}
          handleRatingChangeActive={handleRatingChangeActive}
          MAX_CHARACTERS={MAX_CHARACTERS}
          userId={userId}
          branchId={branchId}
        />
      );
    default:
      return (
        <QRLandingDefault
          employee={employee}
          error={error}
          rating={rating}
          animatedRating={animatedRating}
          isAnimating={isAnimating}
          comment={comment}
          setComment={setComment}
          setError={setError}
          handleRatingChange={handleRatingChange}
          handleRatingChangeActive={handleRatingChangeActive}
          MAX_CHARACTERS={MAX_CHARACTERS}
          userId={userId}
          branchId={branchId}
        />
      );
  }

};

export default QRLanding;
